/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_LinesheetsInputs */

const en_nav_linesheets = /** @type {(inputs: Nav_LinesheetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linesheets`)
};

/**
* | output |
* | --- |
* | "Linesheets" |
*
* @param {Nav_LinesheetsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_linesheets = /** @type {((inputs?: Nav_LinesheetsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_LinesheetsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_linesheets(inputs)
});